import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

const Box = styled.div`
  display: flex;
  padding-right: 24px;
  border-right: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  gap: 12px;
`;

const CountBox = styled.div`
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  svg {
    margin-right: 8px;
  }
`;

const StyledText = styled(Text)`
  span {
    color: ${({ theme }) => theme.colors.black};
  }
`;

interface Props {
  favoritesCount?: number;
  pendingCount?: number;
  failedCount?: number;
}

const ImageToolStatusCount: FC<Props> = ({
  pendingCount,
  failedCount,
  favoritesCount,
}) => {
  return (
    <Box>
      {!!favoritesCount && (
        <CountBox>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
          >
            <path
              d="M7.81811 11.6713L11.4553 13.9081C11.9202 14.194 12.4974 13.7687 12.3595 13.242L11.3086 9.22938C11.279 9.11762 11.2825 9.00002 11.3187 8.89011C11.3549 8.7802 11.4223 8.68244 11.5132 8.60807L14.7748 5.97303C15.2034 5.62679 14.9822 4.93641 14.4316 4.90173L10.1722 4.6334C10.0574 4.62544 9.94741 4.58601 9.85487 4.5197C9.76233 4.4534 9.69111 4.36294 9.64948 4.25886L8.0609 0.375744C8.01772 0.265274 7.94094 0.170167 7.84076 0.103055C7.74057 0.0359426 7.62173 0 7.5 0C7.37828 0 7.25943 0.0359426 7.15925 0.103055C7.05906 0.170167 6.98228 0.265274 6.9391 0.375744L5.35052 4.25886C5.3089 4.36294 5.23767 4.4534 5.14513 4.5197C5.0526 4.58601 4.94256 4.62544 4.82783 4.6334L0.568416 4.90173C0.0178096 4.93641 -0.203387 5.62679 0.225172 5.97303L3.48676 8.60807C3.57765 8.68244 3.64507 8.7802 3.68127 8.89011C3.71747 9.00002 3.72098 9.11762 3.69139 9.22938L2.71683 12.9506C2.55128 13.5827 3.24396 14.093 3.80187 13.7499L7.1819 11.6713C7.27696 11.6125 7.38731 11.5813 7.5 11.5813C7.61269 11.5813 7.72304 11.6125 7.81811 11.6713Z"
              fill="#ED911B"
            />
          </svg>
          <StyledText $type="smallBold" $color="gray">
            Favorited: <span>{favoritesCount}</span>
          </StyledText>
        </CountBox>
      )}
      {!!pendingCount && (
        <CountBox>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_9323_116354)">
              <path
                d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
                fill="#F0AD1C"
              />
              <path
                d="M7 3.5V7.26923H10.7692"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_9323_116354">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <StyledText $type="smallBold" $color="gray">
            Pending: <span>{pendingCount}</span>
          </StyledText>
        </CountBox>
      )}
      {!!failedCount && (
        <CountBox>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
              fill="#F64629"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.71064 5.70711C10.1012 5.31658 10.1012 4.68342 9.71064 4.29289C9.32011 3.90237 8.68695 3.90237 8.29642 4.29289L7.00177 5.58755L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L5.58755 7.00177L4.29289 8.29642C3.90237 8.68695 3.90237 9.32011 4.29289 9.71064C4.68342 10.1012 5.31658 10.1012 5.70711 9.71064L7.00177 8.41598L8.29642 9.71064C8.68695 10.1012 9.32011 10.1012 9.71064 9.71064C10.1012 9.32011 10.1012 8.68695 9.71064 8.29642L8.41598 7.00177L9.71064 5.70711Z"
              fill="white"
            />
          </svg>
          <StyledText $type="smallBold" $color="gray">
            Failed: <span>{failedCount}</span>
          </StyledText>
        </CountBox>
      )}
    </Box>
  );
};

export default ImageToolStatusCount;
